import store from '@/store'
import { onUnmounted, ref, watch } from '@vue/composition-api'
import mapGeofenceStore from '@/views/modules/maps/store/mapGeofenceStore'
import useGeofenceFilter from '@/views/modules/geofence/useGeofenceFilter'

export default function mapGeofence() {


  const MAPS_GEO = 'map_geo'

  if (!store.hasModule(MAPS_GEO))
    store.registerModule(MAPS_GEO, mapGeofenceStore)

  onUnmounted(() => {
    if (store.hasModule(MAPS_GEO))
      store.unregisterModule(MAPS_GEO)
  })


  const geofences = ref([])
  const geofences_orig=ref([])
  const geofencePlanIdes=ref([])
  const loadingFetchgeofenceByDeivce=ref(false)

  const refGeofenceListTable = ref(null)
  const geofenceTableColumns = ['id','name','category']

  const g_requestStatus = ref(false)

  const totalGeofence = ref(0)
  const perPageOptions = [5, 10, 25, 50, 100, 200]
  const geofenceMeta=ref(null)
  const gPerPage = ref(200)
  const gCurrentPage = ref(1)
  const gSearchQuery = ref('')

  const gSortBy = ref('id')

  const gFilter = ref({})


  // const filterOptions = ref(null)


  const {
    gOwnersFilter, gOwnersOptions, gTypeFilter, gTypesOptions,
    gCategoriesOptions, gCategoriesFilter, gContractsFilter, gContractsOptions,gContractsOptions_orig,
    gGroupFilter, gGroupsOptions, gDevicesOptions, gDeviceFilter } = useGeofenceFilter()



  watch([gPerPage, gCurrentPage, gSearchQuery,
    // gTypeFilter,
    gOwnersFilter,
    gDeviceFilter,
    gGroupFilter, gCategoriesFilter, gContractsFilter], () => {
   
    gFilter.value = {
      // ...(gTypeFilter.value && {type: gTypeFilter.value}),
      ...(gGroupFilter.value && {group: gGroupFilter.value}),
      ...(gCategoriesFilter.value && {categories: gCategoriesFilter.value}),
      ...(gContractsFilter.value && {contracts: gContractsFilter.value}),
      ...(gOwnersFilter.value && {owners: gOwnersFilter.value}),
      ...(gDeviceFilter.value && {device: gDeviceFilter.value}),
      ...(gSearchQuery.value && {q: gSearchQuery.value})
    }

    fetchGeofence()
  })


  const fetchGeofence = () => {

    g_requestStatus.value = true
    store.dispatch('map_geo/fetchGeofences', {
      q: gSearchQuery.value,
      length: gPerPage.value,
      page: gCurrentPage.value,
      sortBy: gSortBy.value,
      ...gFilter.value
    })
      .then(response => {
        g_requestStatus.value = false
        const { data } = response.data.data
        const { total } = response.data.data.meta
        geofenceMeta.value=response.data.data.meta
        geofences.value = data
        geofences_orig.value=data
        totalGeofence.value = total

      })
      .catch(() => {
        g_requestStatus.value = false
      })
  }



  const fetchGeofenceByDevice = (device_id) => {
    loadingFetchgeofenceByDeivce.value=true;
    g_requestStatus.value = true
    store.dispatch('map_geo/fetchGeofences', {
      q: gSearchQuery.value,
     // length: gPerPage.value,
     // page: gCurrentPage.value,
      sortBy: gSortBy.value,
      devices:[device_id]
    })
      .then(response => {
        g_requestStatus.value = false
        const { data } = response.data
       // const { total } = response.data.data.meta
        geofences.value = data
        geofences_orig.value=data
       // totalGeofence.value = total
       
      })
      .catch(() => {
        g_requestStatus.value = false
      }).finally(()=>loadingFetchgeofenceByDeivce.value=false)
  }

  const fetchGeofenceByDevicePlan=(device_id)=>{
    loadingFetchgeofenceByDeivce.value=true;
    g_requestStatus.value = true
    store.dispatch('map_geo/fetchGeofences', {     
   
      devicesPlans:[device_id]
    })
      .then(response => {
        g_requestStatus.value = false
        const { data } = response.data
       // const { total } = response.data.data.meta
         data.map(g=> geofencePlanIdes.value.push(g.id))
       // totalGeofence.value = total
       
      })
      .catch(() => {
        g_requestStatus.value = false
      }).finally(()=>loadingFetchgeofenceByDeivce.value=false)



  }


  return {

    g_requestStatus,
    fetchGeofence,
    fetchGeofenceByDevice,
    fetchGeofenceByDevicePlan,
    geofences,
    geofences_orig,
    geofencePlanIdes,
    geofenceTableColumns,

    gContractsOptions,
    gContractsOptions_orig,
    gCategoriesOptions,
    gGroupsOptions,
    gTypesOptions,
    gOwnersOptions,

    gContractsFilter,
    gGroupFilter,
    gTypeFilter,
    gCategoriesFilter,
    gOwnersFilter,
    gFilter,

    gDevicesOptions,
    gDeviceFilter,

    perPageOptions,

    refGeofenceListTable,
    // dataMeta,
    totalGeofence, gPerPage, gCurrentPage, gSearchQuery,loadingFetchgeofenceByDeivce,geofenceMeta
  }
}
